/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventscalendarnoeventsthismonth5Inputs */

const en_eventscalendarnoeventsthismonth5 = /** @type {(inputs: Eventscalendarnoeventsthismonth5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No events this month`)
};

const de_eventscalendarnoeventsthismonth5 = /** @type {(inputs: Eventscalendarnoeventsthismonth5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Events in diesem Monat`)
};

/**
* | output |
* | --- |
* | "No events this month" |
*
* @param {Eventscalendarnoeventsthismonth5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventscalendarnoeventsthismonth5 = /** @type {((inputs?: Eventscalendarnoeventsthismonth5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventscalendarnoeventsthismonth5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventscalendarnoeventsthismonth5(inputs)
	return de_eventscalendarnoeventsthismonth5(inputs)
});
export { eventscalendarnoeventsthismonth5 as "eventsCalendarNoEventsThisMonth" }